import { render, staticRenderFns } from "./PrevLink.vue?vue&type=template&id=d2c7a41a&lang=html&"
import script from "./PrevLink.vue?vue&type=script&lang=js&"
export * from "./PrevLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports